import { getService } from '@Client/runner.hooks/useService';
import React, { useEffect } from 'react';

interface Props {
  reports: IDownloadableReport[];
}

const DownloadableReportTable = ({ reports }: Props) => {
  const fileService = getService('fileService');

  const inProgressDownloads = React.useRef<boolean[]>([]);

  useEffect(() => {
    inProgressDownloads.current = new Array(reports.length).fill(false);
  }, [reports]);

  return (
    <div className="downloadable-reports">
      <table>
        <thead>
          <tr>
            <th className="report-name">Report Name</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {reports.map((report, index) => (
            <tr key={report.url}>
              <td>
                <a
                  href="#"
                  title="Click to download report"
                  onClick={(e) => {
                    e.preventDefault();
                    if (inProgressDownloads.current[index]) {
                      return;
                    }
                    inProgressDownloads.current[index] = true;
                    const cacheDownload = false;
                    fileService
                      .downloadByUrl(
                        report.url +
                          '?' +
                          new URLSearchParams(
                            report.parameters || {}
                          ).toString(),
                        cacheDownload
                      )
                      .then(() => {
                        inProgressDownloads.current[index] = false;
                      })
                      .catch(() => {
                        inProgressDownloads.current[index] = false;
                      });
                  }}
                >
                  {report.name}
                </a>
              </td>
              <td>{report.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export interface IDownloadableReport {
  name: string;
  url: string;
  description?: string;
  parameters?: Record<string, any>;
}

export default DownloadableReportTable;
